import React from 'react';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import './dialogHeader.scss';

const createCancelButton = (onClick: any) => (
  <KFLButton
    id="dialog-cancel"
    key="md-device-cancel"
    variant="borderless"
    onClick={onClick}
  >
    Cancel
  </KFLButton>
);

interface OwnProps {
  buttons: JSX.Element[];
  fnCloseDialog?: any;
  hideCancelBtn?: boolean;
  leftContent?: JSX.Element | string;
}

type Props = OwnProps;
const DialogFooter: React.FC<Props> = (props) => {
  const cancelBtn =
    props.fnCloseDialog && !props.hideCancelBtn
      ? createCancelButton(props.fnCloseDialog)
      : undefined;

  return (
    <div className="ModalDialogFooter">
      <div className="ModalDialogFooterText">{props.leftContent}</div>
      <div className="ModalDialogButtonsArea">
        {cancelBtn}
        {props.buttons.map((bt, idx) => (
          <KFLButton key={`md-key-${idx}`} {...bt.props} />
        ))}
      </div>
    </div>
  );
};

export default DialogFooter;
